import LuxonUtils from '@date-io/luxon';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import {
  DatePicker, MuiPickersUtilsProvider, TimePicker,
} from '@material-ui/pickers';
import classNames from 'classnames';
import React, {
  PureComponent,
} from 'react';
import generalClasses from '../../GeneralFormComponent/GeneralFormComponent.module.scss';
import {
  IDatePickerField,
} from '../formFields';
import classes from './DatePickerField.module.scss';

interface IProps extends IDatePickerField {
  errors: any;
  touched: any;
  withTimePicker?: boolean;

  onChange(name: string, value: Date): any;
}

class DatePickerField extends PureComponent<IProps> {
  render() {
    const {
      label, name, value, minDate, withTimePicker, onChange, errors, touched,
    } = this.props;
    return (
      <FormControl
        className={classNames(generalClasses.filed, classes.container)}
      >
        <DatePicker
          clearable
          variant="inline"
          label={label}
          name={name}
          format="dd/MM/yyyy"
          value={value || null}
          views={['year', 'month', 'date']}
          minDate={minDate}
          onChange={(changedValue: any) => onChange(name, changedValue || new Date())}
        />
        {withTimePicker
          ? (
            <MuiPickersUtilsProvider
              utils={LuxonUtils}
            >
              <TimePicker
                className={classNames(classes.MuiFormControlMargin)}
                margin="normal"
                label="hours and minutes"
                value={value || null}
                onChange={(changedValue: any) => onChange(name, changedValue || new Date())}
              />
            </MuiPickersUtilsProvider>
          ) : null}
        {
            errors[name] && touched[name] ? <FormHelperText className={generalClasses.error}>{errors[name]}</FormHelperText> : null
        }
      </FormControl>
    );
  }
}

export default DatePickerField;
